<div class="d-control-input__icon d-control-input__icon--prepend"><component class="svg-icon" :is="prependIcon"></component></div>